import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(chat)/components/ChatInnerSidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/common/HighlightText.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/layout/Sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/modal/AddNewDashboard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default","success","error"] */ "/vercel/path0/node_modules/react-hot-toast/dist/index.mjs");
